<template>
  <div class="shop-cart">
    <div class="list">
      <el-table
          ref="multipleTable"
          :data="goods_list"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" :selectable="isSelect" width="55"></el-table-column>
        <el-table-column label="产品信息" width="200">
          <template slot-scope="scope">
            <div class="fr afs" style="position: relative">

              <img v-if="Number(scope.row.is_promote) === 1" class="icon-promotion" src="/static/imgs/icon_promotion.png"/>
              <img :src="scope.row.goods_img" class="goods_img" preview="0" alt/>
              <p class="fz12 ellipsis-2line ml10" style="text-align:left">{{ scope.row.goods_name }}
                {{ scope.row.goods_standard_name }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="产品规格">
          <template slot-scope="scope">
            <span>{{ specNameInit(scope.row, 'carSpecificationInputBeans') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="device_name" label="设备信息"/>
        <el-table-column prop="craft_price" label="配套工艺">
          <template slot-scope="scope">
            <el-popover placement="right" width="400" trigger="hover">
              <el-table :data="scope.row.carCraftBeans">
                <el-table-column property="craft_name" label="工艺名称" align="center"></el-table-column>
                <el-table-column property="craft_count" width="90" label="工艺数量" align="center"></el-table-column>
              </el-table>
              <div class="mb10 mt10" v-if="scope.row.craft_remark.length">
                工艺备注信息:
                <span v-html="scope.row.craft_remark"></span>
              </div>
              <el-button type="text" slot="reference" @click="selectCraft(scope.row)">{{
                  scope.row.craft_price
                }}
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="goods_price" label="产品价格"></el-table-column>
        <el-table-column prop="specification_price" label="数量">
          <template slot-scope="scope">
            <el-input-number
                size="mini"
                v-model="scope.row.car_num"
                :min="1"
                @change="carNum(scope.row.car_id,scope.row.car_num)"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="goods_actual_price" label="小计"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
                v-if="hasPermission(909)"
                @click.native.prevent="deleteRow(scope.row.car_id)"
                type="text"
                size="small"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 底部分页 -->
    <div class="footer fr ac jc">
      <el-pagination
          class="mt30 mb30"
          small
          :hide-on-single-page="true"
          layout="prev, pager, next"
          :total="total"
          :current-page.sync="page"
          :page-size="10"
          background
      ></el-pagination>
    </div>
    <div class="foote fr ac jsb">
      <div>
        <el-checkbox
            @click.native="$refs.multipleTable.toggleAllSelection()"
            class="black"
            :value="selectAll"
        >全选
        </el-checkbox>
        <el-button
            type="text"
            v-if="hasPermission(909)"
            class="ml20 black"
            :disabled="!multipleSelection.length"
            @click="deleteRow()"
        >删除
        </el-button>
      </div>
      <div class="fr ac">
        <p class="fr ac mr20">
          <span class="fz12 black">已选商品</span>
          <span class="fz16 orange ml10 mr10">{{ totalLength }}</span>
          <span class="fz12 black">件</span>
        </p>
        <p class="fr ac mr20">
          <span class="fz12 black">合计金额</span>
          <span class="fz16 orange">￥{{ totalPrice }}</span>
        </p>
        <el-button
            type="primary"
            class="submit"
            :disabled="!multipleSelection.length"
            @click="submit"
        >提交订单
        </el-button>
      </div>
    </div>
    <!-- 选择工艺 -->
    <select-craft
        :show.sync="craft_show"
        :length="goods_length"
        :width="goods_width"
        :goods_id="goods_id"
        :select_craft_list.sync="orderCraftBeans"
        @success="updateCarCraft"
    />
  </div>
</template>

<script>
let timer = null;
export default {
  data() {
    return {
      total: 0,
      page: 1,
      goods_id: '',
      goods_list: [],
      multipleSelection: [],
      select: false,
      is_alert: false,
      craft_show: false,
      goods_length: '',
      goods_width: '',
      orderCraftBeans: [],
    };
  },
  computed: {
    totalLength() {
      let sum = 0;
      this.multipleSelection.forEach(el => {
        sum += el.car_num;
      });
      return sum;
    },
    totalPrice() {
      let sum = 0;
      this.multipleSelection.forEach(el => {
        sum = this.add(sum, el.goods_actual_price);
      });
      return sum;
    },
    selectAll() {
      return this.multipleSelection.length === this.goods_list.length && this.goods_list.length !== 0
    }
  },
  created() {
    this.getShopCartList();
  },
  watch: {
    page(n) {
      this.getShopCartList();
    },
    multipleSelection(n) {
      if (n.length > 5 && !this.is_alert) {
        this.$alert('当前订单商品数量已超过5条，如使用平台合同可能导致合同生成异常！如使用客户合同请忽略。', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.is_alert = true;
          }
        });
      }
    }
  },
  methods: {
    selectCraft(goods) {
      goods.carSpecificationInputBeans.forEach(el => {
        this[el.input_name] = el.input_value
      })
      this.orderCraftBeans = goods.carCraftBeans
      this.car_id = goods.car_id;
      this.goods_id = goods.goods_id;
      this.craft_show = true;
    },
    //数组去重
    //如果两个数组不一致返回true
    deduplication(arr1, arr2) {
      let l1 = arr1.length, l2 = arr2.length;
      if (l1 !== l2) return true;
      let obj = {};
      arr1.forEach(el => {
        obj[el.craft_id] = 1;
      })
      arr2.forEach(el => {
        obj[el.craft_id] = 1;
      })
      return Object.keys(obj).length !== l1;
    },
    updateCarCraft() {
      let craft_list = this.orderCraftBeans;
      let o = this.goods_list.find(el => {
        return el.car_id === this.car_id;
      })
      if (this.deduplication(craft_list, o.carCraftBeans)) {
        craft_list.forEach(el => {
          if (el.craft_extra) {
            el.craft_extra = JSON.stringify(el.craft_extra)
          }
        })
        let obj = {
          car_id: this.car_id,
          car_crafts: craft_list
        }
        this.jsonPost("/carInterfaces/v1.0/updateCarCraft", obj).then(res => {

          this.car_id = '';
          this.getShopCartList();
        })
      }
    },
    isSelect(row) {
      return !row.is_disabled;
    },
    // 提交订单
    submit() {
      if (!this.hasMemberType(2)) {
        this.$message({
          type: "warning",
          message: "申请成为客户才能购买商品，暂无权限。"
        });
        return;
      }
      if (!this.multipleSelection.length) {
        this.$message({
          type: "warning",
          message: "未选择商品，无法提交订单"
        });
        return;
      }
      this.multipleSelection.forEach(el => {
        el.specification_inputs = el.carSpecificationInputBeans;
        el.crafts = el.carCraftBeans
      })
      this.$store.commit('setInsertOrder', this.multipleSelection)
      this.go(`confirm`);
    },
    // 修改数量
    carNum(id, num) {
      if (timer != null) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        this.post("carInterfaces/v1.0/updateCarNum", {
          car_id: id,
          car_num: num
        }).then(res => {
        });
      }, 1000);
    },
    // 删除数据
    deleteRow(id) {
      let ids = id ? [id] : [];
      if (!id) {
        if (!this.multipleSelection.length) {
          this.$message({
            type: "warning",
            message: "未选择商品，无法删除"
          });
          return;
        }
        this.multipleSelection.forEach(el => {
          ids.push(el.car_id);
        });
      }
      this.$confirm("此操作将删除该商品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            this.post("carInterfaces/v1.0/deleteCars", {
              car_ids: ids.join(",")
            }).then(res => {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.getShopCartList();
            });
          })
          .catch(() => {
          });
    },
    // 购物车选择
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 获取购物车数据
    getShopCartList() {
      let obj = {
        page: -1,
        pageSize: -1,
        //如果是销售代客下单，type传2 客户自主下单传1
        checkout_type: this.is_Empty(this.$store.state.sale_info) ? 1 : 2
      }
      this.post("carInterfaces/v1.0/getCarsV2", obj).then(res => {
        if (res.status === "ok") {
          let arr = res.data;
          arr.forEach(el => {

            el.is_disabled = el.carCraftBeans.some((e) => {
              return e.is_delete === 1
            }) || this.is_Empty(el.goods_actual_price)
          })
          this.total = res.total;
          this.goods_list = arr;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.shop-cart {
  width: 1200px;
  margin: 0 auto;
  padding: 10px 0;
  .icon-promotion{
    width: 50px;
    height: 50px;
    position: absolute;
    left: 0;
    top: 0;
  }
  .list {
    width: 100%;
    background-color: #fff;
    padding: 20px 0;

    .el-table {
      .el-table__header-wrapper {
        .cell {
          text-align: center;
        }
      }

      .goods_img {
        width: 60px;
        height: 60px;
        flex-shrink: 0;
      }

      .el-table__row {
        .cell {
          text-align: center;

          .el-input-number {
            width: 90%;
          }
        }
      }
    }
  }

  .footer {
    width: 100%;

    .el-pagination {
      .el-pager {
        .number {
          border: 1px solid #979797;
        }

        .active {
          border: none !important;
        }
      }
    }
  }

  .foote {
    width: 100%;
    height: 50px;
    background-color: #e3e3e3;
    margin-top: 20px;
    padding-left: 20px;

    .submit {
      width: 120px;
      height: 50px;
      border-radius: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/homePage/shopCart/index.vue